<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="会议详情"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12" v-if="msg.is_custom_room == 1">
                        <div class="label">公司会议室：</div>
                        <div class="content">{{ msg.address_name }}</div>
                    </el-col>
                    <el-col :span="12" v-else>
                        <div class="label">自定义地点：</div>
                        <div class="content">{{ msg.address_name }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">会议时间：</div>
                        <div class="content">
                            {{ msg.meeting_date }}
                            {{ msg.meeting_start_time }} 至
                            {{ msg.meeting_end_time }}
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">参会人：</div>
                        <div class="content">{{ msg.conferee_cn }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">主持人：</div>
                        <div class="content">{{ msg.user_name }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">会议主题：</div>
                        <div class="content">{{ msg.title }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">会议内容：</div>
                        <div class="content">
                            <!-- <vue-tinymce
                                v-if="detailVisible"
                                v-model="msg.content"
                                :setting="setting"
                            /> -->
                            <el-input
                                type="textarea"
                                placeholder="会议内容"
                                size="small"
                                v-model="msg.content"
                                :autosize="{ minRows: 10, maxRows: 12 }"
                                readonly
                            >
                            </el-input>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-if="msg.summary!=''">
                    <el-col :span="24">
                        <div class="label">会议总结：</div>
                        <div class="content">
                            <!-- <vue-tinymce
                                v-if="detailVisible"
                                v-model="msg.summary"
                                :setting="setting"
                            /> -->
                            <el-input
                                type="textarea"
                                placeholder="会议总结"
                                size="small"
                                v-model="msg.summary"
                                :autosize="{ minRows: 10, maxRows: 12 }"
                                readonly
                            >
                            </el-input>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" v-if="msg.complete_time">
                        <div class="label">总结时间：</div>
                        <div class="content">{{ msg.summary_time }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" v-if="msg.complete_time">
                        <div class="label">完成时间：</div>
                        <div class="content">{{ msg.complete_time }}</div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import { mapState } from "vuex";
export default {
    data() {
        return {
            msg: {}
        };
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.meetingList();
                }
            }
        }
    },
    created() {},
    methods: {
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        meetingList() {
            oaApi.meetingList({}, "get", this.tableItem.id).then(res => {
                //console.log(res);
                if (res.code == 200) {
                    this.msg = res.data;
                }
            });
        }
    },
    components: {},
    computed: {
        ...mapState({
            setting: state =>
                Object.assign(JSON.parse(JSON.stringify(state.index.setting)), {
                    readonly: true
                })
        })
    }
};
</script>

<style lang="scss" scoped>

</style>
